export abstract class ASelector {
  id: string;
  libelle: string;
}
export interface IProduit extends ASelector {
  libelle_total?: string;
  actif_modalite?: boolean;
  objectif_formation?: string;
  prix_catalogue_intra?: number;
  prix_catalogue_inter?: number;
  reference?: string;
  duree_h?: number;
  effectif_mini?: number;
  effectif_maxi?: number;
  libelle_modalite?: string;
  id_tva?: string;
  actif?: boolean;
  points_forts?: string;
  mentions?: string;
  duree_j?: number;
  type_modalite?: number;
  habilitation?: any;
  id_produit?: string;
}

export interface IPays extends ASelector {
  nom_fr: string;
}

export interface ISector extends ASelector {
  id_organisme_formation: string;
}

export type IFamile_Group_Site = ASelector
export interface IStatut_Session extends ASelector {
  code: string;
  couleur: string;
  id_organisme_formation: string;
}
export interface IPeriod {
  dateBeginPeriode: string;
  dateEndPeriod: string;
}

export interface ITypeApprenantSelector extends ASelector {
  code: string;
}
export interface IIntervenantDepartementsSelector extends ASelector {
  numero: string;
}

export interface IPays extends ASelector {
  nom_fr: string;
}
export interface IMotifAbsenceSelector extends ASelector {
  b_defaut: boolean;
}
